import { api } from './api';
import config from 'config';

import jwtDecode from 'jwt-decode';
import { hasValue } from 'swipeclock-frontend';

// NOTE: Read config.* inside each query closure rather than at module scope.
// URLs are build-time constants per mobile artifact (one env per channel).

export const loginApi = api.injectEndpoints({
  endpoints: (build) => ({
    postTWPLogin: build.mutation({
      query: ({ body }) => {
        return {
          url: `${config.authServiceUrl}/OwnerCredentialsGrant/login`,
          method: 'POST',
          body,
        };
      },
      transformResponse: async (res) => {
        let roles = [];
        const { jwt = '' } = res || {};
        if (jwt) {
          const decoded = jwtDecode(jwt);
          roles = decoded.roles;
        }

        let data = {
          token: res?.jwt,
          roles,
          siteId: res?.info?.site?.id,
          siteName: res?.info?.site?.name,
          jwtStatus: res?.jwtStatus,
        };

        if (hasValue(res.errorType)) {
          data = res;
        }

        return data;
      },
    }),
    postResetPassword: build.mutation({
      query: ({ body }) => {
        return {
          url: `${config.twpApiURL}/9999/employees/reset_password`,
          method: 'POST',
          body,
        };
      },
    }),
    postSetPassword: build.mutation({
      query: ({ body }) => {
        return {
          url: `${config.twpApiURL}/9999/employees/set_password`,
          method: 'POST',
          body,
        };
      },
    }),
    postUpdatePassword: build.mutation({
      query: ({ body }) => {
        const { jwt } = body;
        return {
          url: `${config.twpApiURL}/${body.site}/employees/update_password`,
          method: 'POST',
          headers: {
            Authorization: `Bearer ${jwt}`,
            'Content-Type': 'application/json',
          },
          body,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  usePostTWPLoginMutation,
  usePostResetPasswordMutation,
  usePostSetPasswordMutation,
  usePostUpdatePasswordMutation,
} = loginApi;
